<template>
  <Transition name="fade" mode="out-in">
    <component :is="activeComponent"></component>
  </Transition>
</template>


<script>
import LoginWindow from '@/pages/login/LoginWindow.vue'
import DashboardWindow from '@/components/WindowDashboard.vue'
import { shallowRef } from 'vue'
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'MainPage',
  data() {
    return {
      status: true,
      activeComponent: shallowRef(LoginWindow)
    }
  },
  components: {
    LoginWindow,
    DashboardWindow
  },
  watch: {
    'userOptions.loginStatus'(newStatus) {
      if (newStatus) {
        this.activeComponent = shallowRef(DashboardWindow)
      } else {
        this.activeComponent = shallowRef(LoginWindow)
      }
    }
  },
  computed: {
    ...mapGetters('user', {
      userOptions: 'getUserOptions'
    })
  },
  methods: {
    ...mapActions('user', {
      checkUserInfo: 'checkUserInfo'
    })
  },
  created() {
    document.title = "MVLab | Vibro | Вибромониторинг | Вибродиагностика | Облачный сервис";
    this.checkUserInfo()
  }
}
</script>
